import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppSelector } from '../hooks'

export const NavBack: React.FC<{
  theme?: string
  handler?: Function
}> = (props) => {
  const { theme = 'default', handler } = props

  const [isFormPublic, setIsFormPublic] = useState(false)
  const [classHistory, setClassHistory] = useState<string[]>([])
  const navRef = useRef<HTMLDivElement | null>(null)

  const authState = useAppSelector((state) => state.auth)
  const { data: authUser } = authState
  const formState = useAppSelector((state) => state.form)
  const { form } = formState
  const submissionState = useAppSelector((state) => state.submission)
  const { submission } = submissionState
  const navigate = useNavigate()
  const { pathname } = useLocation()
  let routeName = ''

  useEffect(() => {
    setTheme(theme)
    // eslint-disable-next-line
  }, [theme])

  useEffect(() => {
    if (form && submission && form._id === submission.formId) {
      setIsFormPublic(form.isPublic)
    }
  }, [form, submission])

  if (pathname.includes('form')) {
    if (pathname.includes('preview')) {
      routeName = 'Preview'
    } else if (pathname.includes('edit')) {
      if (pathname.includes('new')) {
        routeName = 'New form'
      } else {
        routeName = 'Editing'
      }
    } else if (pathname.includes('submit')) {
      routeName = `New ${isFormPublic ? 'response' : 'entry'}`
    } else if (pathname.includes('review')) {
      routeName = 'Review'
    } else if (pathname.includes('submission')) {
      routeName = `Viewing ${isFormPublic ? 'response' : 'entry'}`
    }
  }

  const setTheme = (name: string) => {
    const themeHistory = [...classHistory]

    themeHistory.push(name)

    if (themeHistory.length > 2) {
      themeHistory.shift()
    }

    setClassHistory(themeHistory)

    const removeFromClass = `theme-content-${themeHistory[0]}`
    navRef.current?.classList.remove(removeFromClass)

    if (themeHistory.length > 1) {
      const addToClass = `theme-content-${themeHistory[1]}`
      navRef.current?.classList.add(addToClass)
    } else {
      const addToClass = `theme-content-${themeHistory[0]}`
      navRef.current?.classList.add(addToClass)
    }
  }

  return (
    <div className='nav_container' ref={navRef}>
      <div className='nav-back' onClick={() => (handler ? handler() : navigate(-1))}>
        <span className='material-symbols-rounded'>arrow_left_alt</span>
      </div>
      {authUser && routeName && <span className='badge'>{routeName}</span>}
    </div>
  )
}
